import * as React from "react"

export const RosetteIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="currentColor"
      d="m8.25 11.678.669-2.18-1.75-1.314h2.15L10 6.014l.681 2.17h2.151L11.09 9.498l.668 2.18L10 10.333zm-2.354 7.18v-5.36Q5 12.775 4.46 11.524A6.3 6.3 0 0 1 3.917 9q0-2.532 1.776-4.308Q7.468 2.917 10 2.917t4.308 1.775T16.084 9q0 1.293-.5 2.534-.501 1.242-1.5 1.985v5.34L10 18.067zM10 14q2.085 0 3.542-1.459Q15 11.083 15 9q0-2.085-1.458-3.542Q12.084 4 10 4T6.46 5.458Q4.999 6.916 5 9T6.46 12.54Q7.917 14.002 10 14m-3.02 3.633 3.02-.707 3 .707v-3.388a5.3 5.3 0 0 1-1.436.63 6 6 0 0 1-1.564.208 6.4 6.4 0 0 1-1.574-.197 4.7 4.7 0 0 1-1.447-.641z"
    ></path>
  </svg>
)
